export const getRevisionTitle = (revision: {name?: string | null} | undefined, version: number | undefined) => {
    if (!revision) {
        return "No revision"
    }
    return (version ?? "?") + " - " + (revision.name ?? "Untitled")
}
